import React from 'react';
import { ExpandVideoIcon } from '@/assets/icons/v2/ExpandVideo';
import { MinimizeVideoIcon } from '@/assets/icons/v2/MinimizeVideo';
import { ICON_SIZE } from '../../utils/constants';

import * as S from '../../styles';

const MINIMIZE_ICONS = {
	expanded: ExpandVideoIcon,
	minimized: MinimizeVideoIcon
} as const;

interface MinimizeProps {
	minimized: boolean;
	onToggleMinimized: () => void;
	fill?: string;
}

export function Minimize({ minimized, onToggleMinimized, fill }: Readonly<MinimizeProps>): JSX.Element {
	const IconComponent = minimized ? MINIMIZE_ICONS.expanded : MINIMIZE_ICONS.minimized;

	return (
		<S.ControlItem>
			<S.ControlButton
				icon={
					<S.HoverIcon>
						<IconComponent width={ICON_SIZE} height={ICON_SIZE} fill={fill} />
					</S.HoverIcon>
				}
				onClick={onToggleMinimized}
			/>
		</S.ControlItem>
	);
}
